import _                                        from 'underscore';
import React, { ReactNode }                     from 'react';
import { StyledContainer }                      from "../../containers";
import { CorvalUIColor, SemanticUIColor, Size } from "../../../types";
import { Cell, Grid }                           from "styled-css-grid";
import { Divider, Header, Icon, IconProps }     from "semantic-ui-react";
import { FieldLabel }                           from "../forms/formik/FieldLabel";
import { FinePrintMessage }                     from "../util/messaging/FinePrintMessage";


interface FocusedContentWithTeamSupportListProps {
    contentTitle: ReactNode,
    contentDescription?: ReactNode,
    contentIndicators?: ReactNode,
    contentIcon: Omit<IconProps, 'size'>,
    teamSupportListContent: ReactNode,
    focusedContentHeaderContent: ReactNode,
    focusedContentMainContent: ReactNode,
    focusedContentMaxHeight: string,
}

const FocusedContentWithTeamSupportListDefaultProps = {
    contentTitle:                'Title',
    contentDescription:          'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    contentIndicators:           null,
    contentIcon:                 { name: 'users', color: SemanticUIColor.TEAL } as IconProps,
    teamSupportListContent:      null,
    focusedContentHeaderContent: null,
    focusedContentMainContent:   null,
    focusedContentMaxHeight:     `auto`
} satisfies Partial<FocusedContentWithTeamSupportListProps>

function FocusedContentWithTeamSupportList( p: FocusedContentWithTeamSupportListProps ){

    const props = { ...FocusedContentWithTeamSupportListDefaultProps, ...p };

    return (
        <>
            <StyledContainer padding={ [ Size.MD, Size.LG ] } bgColor={ CorvalUIColor.LUNAR }>

                <Grid areas={ [ 'icon header indicator', '. content content' ] } rows={ 'auto auto' } columns={ `35px minmax(auto,60%) auto` } columnGap={ '0px' } rowGap={ '0px' }>

                    <Cell center area={ 'icon' }>

                        <Icon size={ 'large' } { ...props.contentIcon }/>

                    </Cell>
                    <Cell area={ 'header' }>

                        <Header as={ 'h3' } color={ 'purple' }>{ props.contentTitle }</Header>

                    </Cell>
                    <Cell area={ 'content' }>

                        { props.contentDescription && _.isString( props.contentDescription ) ? <p>{ props.contentDescription }</p> : props.contentDescription }

                    </Cell>
                    <Cell area={ 'indicator' } className={ 'text-right' }>

                        { props.contentIndicators && _.isString( props.contentIndicators ) ? <p>{ props.contentIndicators }</p> : props.contentIndicators }

                    </Cell>
                </Grid>

            </StyledContainer>

            <Divider className={ 'no-margin-top' }/>

            <StyledContainer padding={ [ Size.MD, Size.LG ] }>

                <Grid areas={ [ 'teamDesc focusedHeader', 'team focusedMainContent' ] } columns={ `300px 1fr` } rows={ `auto minmax(auto, ${ props.focusedContentMaxHeight } )` } columnGap={ '25px' }>

                    {/* Team Support List Header */ }
                    <Cell area={ 'teamDesc' }>

                        <FieldLabel>Team Members</FieldLabel>
                        <FinePrintMessage>These project members may be able to help inform decisions.</FinePrintMessage>

                    </Cell>

                    {/* Team Support List */ }
                    <Cell area={ 'team' } className={ 'overflow-content--y padding-sm-right' }>

                        { props.teamSupportListContent }

                    </Cell>

                    {/* Focused Content Header / Controls */ }
                    <Cell area={ 'focusedHeader' } className={ 'padding-sm-right' }>

                        { props.focusedContentHeaderContent }

                    </Cell>

                    {/* Main Focused Content */ }
                    <Cell area={ 'focusedMainContent' } className={ 'overflow-content--y padding-sm-right' }>

                        { props.focusedContentMainContent }

                    </Cell>
                </Grid>

            </StyledContainer>
        </>
    );
}

export {
    FocusedContentWithTeamSupportList,
    FocusedContentWithTeamSupportListDefaultProps,
    type FocusedContentWithTeamSupportListProps,
};
